import api from "../../../hooks/api";
import { useAxios } from "../../../hooks/axios";
import Loader from "../Loader";
import { toast } from "react-toastify";
import { isAxiosError, HttpStatusCode } from "axios";
import { ReactNode, useCallback, useState } from "react";
import ConfirmActionDialog from "./ConfirmActionDialog";

export const RadixRecordingDialog = (props: {
  roomId: string;
  start: boolean;
  trigger: ReactNode;
}) => {
  const [open, setOpen] = useState(false);

  const axios = useAxios();
  const startRecording = api.useStartRecording(axios);
  const stopRecording = api.useStopRecording(axios);
  const [loading, setLoading] = useState(false);

  const toggleRecording = useCallback(async () => {
    try {
      setLoading(true);
      props.start
        ? await startRecording({ roomId: props.roomId })
        : await stopRecording({ roomId: props.roomId });
      setOpen(false);
    } catch (error) {
      if (
        isAxiosError(error) &&
        error.response?.status === HttpStatusCode.Forbidden
      ) {
        toast(
          <div className="Toast ErrorToast">
            {"Your organization is out of minutes"}
          </div>,
          {
            type: "error",
          }
        );
      } else {
        toast(
          <div className="Toast ErrorToast">
            {"Something went wrong, please try again"}
          </div>,
          {
            type: "error",
          }
        );
      }
      throw error;
    } finally {
      setLoading(false);
    }
  }, [props.roomId, props.start, startRecording, stopRecording]);

  return (
    <ConfirmActionDialog
      title={`${props.start ? "Start" : "Stop"} recording`}
      trigger={props.trigger}
      content={
        loading ? (
          <Loader inline={true} />
        ) : (
          <h3>
            Are you sure you want to {props.start ? "start" : "stop"} the
            recording?
          </h3>
        )
      }
      action="Yes"
      onConfirm={toggleRecording}
      open={open}
      onOpenChange={setOpen}
      disabled={loading}
    />
  );
};

export default RadixRecordingDialog;
